'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.intl = exports.default = undefined;

var _intl = require('./intl');

var _intl2 = _interopRequireDefault(_intl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var intl = new _intl2.default();

function defaultIntl() {
  return intl.msg.apply(intl, arguments);
}

defaultIntl.register = intl.register;
defaultIntl.date = intl.formatDate;
defaultIntl.addMessages = intl.addMessages;
defaultIntl.reset = intl.reset;
defaultIntl.setLocale = intl.setLocale;
defaultIntl.getLocale = intl.getLocale;
defaultIntl.getLocaleKey = intl.getLocaleKey;
defaultIntl.msg = intl.msg;
defaultIntl.momentTimezone = intl.momentTimezone; // 已经废弃，保留版本向前兼容

exports.default = defaultIntl;
exports.intl = intl;